import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import {
  MessageBaseModel,
  MessageSource,
  MESSAGE_SOURCES_METADATA,
  ReviewModel,
} from '@boxx/messages-core';
import { ConversationItemOpenComponent } from '../conversation-item-open/conversation-item-open.component';

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'boxx-review-item-open',
  templateUrl: './review-item-open.component.html',
  styleUrls: ['./review-item-open.component.scss'],
})
export class ReviewItemOpenComponent
  extends ConversationItemOpenComponent
  implements OnInit, OnDestroy
{
  @Input() override set message(payload: ReviewModel) {
    this.myMessage = payload;
  }

  override get message(): ReviewModel {
    return this.myMessage as ReviewModel;
  }

  // eslint-disable-next-line @typescript-eslint/naming-convention
  override MESSAGE_SOURCE = MessageSource;
  messageSources = MESSAGE_SOURCES_METADATA;

  constructor() {
    super();
  }

  ngOnInit(): void {}

  ngOnDestroy() {}
}
